var map = {
	"./amex.png": "632f",
	"./diners.png": "4703",
	"./discover.png": "aa7c",
	"./jcb.png": "904c",
	"./mastercard.png": "f8e8",
	"./unionpay.png": "a7a7",
	"./visa.png": "3edc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2896";